import React, { useState } from 'react';
import styled from 'styled-components';
import { Typography, Card, Collapse } from '@material-ui/core';
import { colors } from 'styles';

const PurpleText = styled(Typography)`
  color: ${colors.shades.purple.dark};
`;

const Title = styled(PurpleText)`
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  color: ${({expanded}) => expanded && colors.lightBlue};
`;

const CustomCard = styled(Card)`
  width: 97%;
  margin-top: 1.5em;
  padding: 1em;
`;

const Text = styled(PurpleText)`
  font-size: 1em !important;
`;

const QuestionCard = ({ question }) => {
  const [expanded, setExpanded] = useState(false);
  const {
    html,
    frontmatter: { title },
  } = question;
  return (
    <CustomCard>
      <Title variant="body2" expanded={expanded} aria-expanded={expanded} onClick={() => setExpanded(!expanded)} >{title}</Title>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Text variant="body2" dangerouslySetInnerHTML={{__html: html}} />
      </Collapse>
    </CustomCard>
  );
};

export default QuestionCard;
